export default __webpack_public_path__ + "static/media/user_icon.6d1ccd22.svg";